import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { Upload, Icon, Modal } from 'antd'

const getBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

const UploadImages = ({ images, uploadImage, removeImage }) => {
  const [preview, setPreview] = useState({
    previewVisible: false,
    previewImage: ''
  })
  const [fileList, setFileList] = useState([])

  useEffect(() => {
    setFileList(images)
  }, [images])

  const handleChange = ({ fileList }) => {
    setFileList(fileList)
  }
  const handleCancel = () => setPreview({ previewVisible: false })

  const handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    }
    setPreview({
      previewImage: file.url || file.preview,
      previewVisible: true
    })
  }

  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  return (
    <div className="clearfix">
      <Upload
        customRequest={({ file }) => uploadImage(file)}
        listType="picture-card"
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
        onRemove={({ id }) => removeImage(id)}
      >
        {fileList.length >= 10 ? null : uploadButton}
      </Upload>
      <Modal
        visible={preview.previewVisible}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          alt="example"
          style={{ width: '100%' }}
          src={preview.previewImage}
        />
      </Modal>
    </div>
  )
}

UploadImages.propTypes = {
  images: PropTypes.array.isRequired,
  uploadImage: PropTypes.func.isRequired,
  removeImage: PropTypes.func.isRequired
}

export default UploadImages



// WEBPACK FOOTER //
// ./src/components/UploadImages/index.js